import type { IBrand } from "../../../../types/models/brands.models.types";
import { useGetHttp } from "../../http.hook";

interface IResponse {
  brands: Array<IBrand>;
}

export function useSearchBrandsAdminHttp() {
  return useGetHttp<IResponse>({
    path: "/admin/brands/search",
  });
}
